import React, { useState, useEffect } from 'react';
import { Container, Button, Row, Col, Form, Alert, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { buildUrl, formatDouble } from '../helper/handler';
import { getFromApi, postToApi } from '../utilities/NetUtilities';
import { SpinnerComp } from '../helper/spinner';
import moment from 'moment';

function Obiettivi730() {
    const [nomeOrganizzazione, setNomeOrganizzazione] = useState("");
    const [tipoOrganizzazione, setTipoOrganizzazione] = useState("");
    const [durataAppuntamento, setDurataAppuntamento] = useState(30);
    const [message, setMessage] = useState(null);
    const [obiettivi, setObiettivi] = useState([]);
    const [reports, setReports] = useState({});
    const [loadingMap, setLoadingMap] = useState({});
    const [tutti, setTutti] = useState(false);

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        if (organizzazioneMap) {
            setNomeOrganizzazione(organizzazioneMap.nome);
            setTipoOrganizzazione(organizzazioneMap.tipo);
            loadData(organizzazioneMap, tutti);
        }
    },[tutti]);

    const loadData = (org, isTutti) => {
        const params = { nome: org.nome, tipo: org.tipo };
        const urlOrg = buildUrl('selezionaorganizzazione', params);
        getFromApi(urlOrg, (data) => {
            setDurataAppuntamento(data.response.durataAppuntamento || 30);
        }, () => {});

        const paramsObiettivi = { organizzazione: org.nome, tipo: org.tipo, tutti: isTutti };
        const urlObiettivi = buildUrl('obiettivi730', paramsObiettivi);
        getFromApi(urlObiettivi, (data) => {
            setObiettivi(data.obiettivi || []);
        }, () => {});
    };

    const salvaDurataAppuntamento = () => {
        const params = {
            organizzazione: nomeOrganizzazione,
            tipo: tipoOrganizzazione,
            durataAppuntamento: durataAppuntamento
        };
        const url = buildUrl('savedurataappuntamento');
        postToApi(url, params, 
            (data) => { setMessage({ tipo: "primary", descrizione: data.messaggi[0].descrizione }); },
            (data) => { setMessage({ tipo: "danger", descrizione: data.messaggi[0].descrizione }); }
        );
    };

    const loadReport = (obiettivo) => {
        if (reports[obiettivo.id]) {
            const newReports = { ...reports };
            delete newReports[obiettivo.id];
            setReports(newReports);
            return;
        }
        setLoadingMap(prev => ({ ...prev, [obiettivo.id]: true }));
        const url = buildUrl('obiettivi730report', { id: obiettivo.id });
        getFromApi(url, (data) => {
            setReports(prev => ({ ...prev, [obiettivo.id]: data.report || [] }));
            setLoadingMap(prev => ({ ...prev, [obiettivo.id]: false }));
        }, () => {
            setLoadingMap(prev => ({ ...prev, [obiettivo.id]: false }));
        });
    };

    const okActionFreeze = (data) => {
        setMessage({ tipo: "primary", descrizione: data.messaggi[0].descrizione });
    };

    const errorActionFreeze = (data) => {
        setMessage({ tipo: "danger", descrizione: data.messaggi[0].descrizione });
    };

    const handleFreeze = (obiettivoId) => {
        const url = buildUrl('obiettivi730freeze');
        postToApi(url, { id: obiettivoId }, okActionFreeze, errorActionFreeze);
    };

    const formatDate = (dateStr) => {
        return moment(dateStr).format('DD/MM/YYYY');
    };

    return (
        <div className='main' role="main">
            <Container fluid>
                <h1 className="d-flex justify-content-center">Obiettivi 730 ({nomeOrganizzazione.toLowerCase()}/{tipoOrganizzazione.toLowerCase()})</h1>
                {message && <Alert variant={message.tipo} id="message" className='mt-3'>{message.descrizione}</Alert>}
                
                <Row className="mt-4 mb-2">
                    <Col></Col>
                    <Col xs="auto">
                        <Form.Group className="d-flex align-items-center mb-0">
                            <Form.Check 
                                type="checkbox"
                                label="mostrare tutti gli anni"
                                checked={tutti}
                                onChange={(e) => setTutti(e.target.checked)}
                                className="mr-4"
                                id="mostra_tutti_gli_anni"
                            />
                            <Form.Label className="mb-0 mr-2" style={{whiteSpace: 'nowrap'}}>Durata appuntamento (minuti)</Form.Label>
                            <Form.Control 
                                type="number" 
                                id="durataAppuntamento" 
                                value={durataAppuntamento}
                                style={{width: '80px'}}
                                onChange={(e) => setDurataAppuntamento(parseInt(e.target.value) || 0)}
                                onBlur={salvaDurataAppuntamento}
                                className="mr-3"
                            />
                            <Button 
                                className="btnGenerale" 
                                variant="flat" 
                                as={Link}
                                to="/gestioneobiettivi730"
                                id="vai_a_gestione_obiettivi_730"
                            >
                                gestione obiettivi
                            </Button>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col>
                        <div className="d-flex flex-column align-items-start w-100">
                            {obiettivi.map((ob, index) => (
                                <React.Fragment key={ob.id}>
                                    <div className="d-flex align-items-center mb-2">
                                        <Button 
                                            variant=""
                                            size="sm"
                                            className="dropdown-toggle btnGenerale mr-2"
                                            aria-controls="espandere tabella" 
                                            aria-expanded={reports[ob.id] ? true : false}
                                            onClick={() => loadReport(ob)}
                                            style={{width: '300px'}}
                                            id={`obiettivo_${index}`}
                                        >
                                            {formatDate(ob.dataObiettivo)} - {formatDouble(ob.percentualeIncremento)}% - {formatDate(ob.dataDisponibilita)}
                                        </Button>
                                        <Button 
                                            variant="flat" 
                                            size="sm" 
                                            className="btnGenerale mr-2"
                                            onClick={() => handleFreeze(ob.id)}
                                            id={`freeze_${index}`}
                                        >
                                            freeze
                                        </Button>
                                        <Button 
                                            variant="flat" 
                                            size="sm" 
                                            className="btnGenerale"
                                            as={Link}
                                            to={`/obiettivi730files?id=${ob.id}`}
                                            id={`view_freeze_${index}`}
                                        >
                                            file freeze
                                        </Button>
                                    </div>                                    
                                    {(loadingMap[ob.id] || reports[ob.id]) && (
                                        <div className="mt-2 mb-5 w-100">
                                            {loadingMap[ob.id] ? (
                                                <div className="d-flex justify-content-center mt-4"><SpinnerComp /></div>
                                            ) : (
                                                <Table striped bordered hover responsive size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>Sede</th>
                                                        <th className="text-center">Stampati</th>
                                                        <th className="text-center">In modifica</th>
                                                        <th className="text-center">Totale</th>
                                                        <th className="text-center">730 previsti</th>
                                                        <th className="text-center">Slot disponibili</th>
                                                        <th className="text-center">Ipotesi produzione</th>
                                                        <th className="text-center">730 da raggiungere</th>
                                                        <th className="text-center">730 mancanti</th>
                                                        <th className="text-center">Ore necessarie</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reports[ob.id].map((row, idx) => (
                                                        <tr key={idx}>
                                                            <td>{row.sede}</td>
                                                            <td className="text-right">{row.stampati}</td>
                                                            <td className="text-right">{row.inModifica}</td>
                                                            <td className="text-right"><strong>{row.totale}</strong></td>
                                                            <td className="text-right">{row.previsti730}</td>
                                                            <td className="text-right">{row.slotDisponibili}</td>
                                                            <td className="text-right"><strong>{row.ipotesiProduzione}</strong></td>
                                                            <td className="text-right">{row.daRaggiungere730}</td>
                                                            <td className="text-right"><strong>{row.mancanti730}</strong></td>
                                                            <td className="text-right" style={{ color: row.oreNecessarie < 0 ? 'red' : 'inherit' }}>{formatDouble(row.oreNecessarie)}</td>
                                                        </tr>
                                                    ))}
                                                    {reports[ob.id].length > 0 && (
                                                        <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                                                            <td><strong>TOTALE</strong></td>
                                                            <td className="text-right"><strong>{reports[ob.id].reduce((sum, row) => sum + row.stampati, 0)}</strong></td>
                                                            <td className="text-right"><strong>{reports[ob.id].reduce((sum, row) => sum + row.inModifica, 0)}</strong></td>
                                                            <td className="text-right"><strong>{reports[ob.id].reduce((sum, row) => sum + row.totale, 0)}</strong></td>
                                                            <td className="text-right"><strong>{reports[ob.id].reduce((sum, row) => sum + row.previsti730, 0)}</strong></td>
                                                            <td className="text-right"><strong>{reports[ob.id].reduce((sum, row) => sum + row.slotDisponibili, 0)}</strong></td>
                                                            <td className="text-right"><strong>{reports[ob.id].reduce((sum, row) => sum + row.ipotesiProduzione, 0)}</strong></td>
                                                            <td className="text-right"><strong>{reports[ob.id].reduce((sum, row) => sum + row.daRaggiungere730, 0)}</strong></td>
                                                            <td className="text-right"><strong>{reports[ob.id].reduce((sum, row) => sum + row.mancanti730, 0)}</strong></td>
                                                            <td className="text-right" style={{ color: reports[ob.id].reduce((sum, row) => sum + row.oreNecessarie, 0) < 0 ? 'red' : 'inherit' }}><strong>{formatDouble(reports[ob.id].reduce((sum, row) => sum + row.oreNecessarie, 0))}</strong></td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                            )}
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Obiettivi730;

